import React from "react";

import { Button, SearchInput } from "@toddle-edu/ds-web";
import { AddOutlined } from "@toddle-edu/ds-icons";
import useI18n from "Hooks/UseI18n";
import { useDispatch } from "Hooks/useDispatch";
import {
  goToMessagingV2FormTemplateRoute,
  setFormTemplateModal,
} from "MessagingV2/modules/MessagingModule";
import { useChatOptions } from "MessagingV2/providers/ChatOptionsProvider";

import CreatorsFilter from "./CreatorsFilter";
import classes from "./FormTemplateFilterHeader.scss";

const FormTemplateFilterHeader = props => {
  const { selectedUsers, setSelectedUsers, setSearchText, searchText } = props;
  const { t } = useI18n(["common"]);
  const { chatId } = useChatOptions();

  const dispatch = useDispatch();
  const onCreateNewTemplate = () => {
    dispatch(setFormTemplateModal(false));
    dispatch(goToMessagingV2FormTemplateRoute({ chatId }));
  };

  return (
    <div className={classes.filterHeaderContainer}>
      <div className={classes.filterHeaderLeftContainer}>
        <SearchInput
          focusSearchBySlash
          onChange={setSearchText}
          value={searchText}
          dsVersion="2.0"
          variant="plain"
          placeholder={`${t("common:search_for_a_with_label", {
            label: t("common:form_template"),
          })}...`}
        />
      </div>

      <div className={classes.filterHeaderRightContainer}>
        <CreatorsFilter
          selectedUsers={selectedUsers}
          setSelectedUsers={setSelectedUsers}
        />
        <Button
          dsVersion="2.0"
          variant="primary"
          type="fill"
          icon={<AddOutlined />}
          onClick={onCreateNewTemplate}
        >
          {t("common:create_new_label", {
            label: t("common:template"),
          })}
        </Button>
      </div>
    </div>
  );
};

export default FormTemplateFilterHeader;
